import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, UrlTree } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, take, timeout } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(
        private _msalService: MsalService,
        private _msalBroadcastService: MsalBroadcastService
    ) { }

    canActivate(
        next: ActivatedRouteSnapshot,
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (this.ensureActiveAccount()) {
            return true;
        }

        // During initial app startup, MSAL may still be processing redirect state.
        // Wait for interaction to settle, then enforce account presence.
        return this._msalBroadcastService.inProgress$.pipe(
            filter((status: InteractionStatus) => status === InteractionStatus.None),
            take(1),
            timeout(5000),
            map(() => this.ensureActiveAccount()),
            catchError(() => of(false))
        );
    }

    private ensureActiveAccount(): boolean {
        let accountInfo = this._msalService.instance.getActiveAccount();

        if (!accountInfo) {
            const accounts = this._msalService.instance.getAllAccounts();
            if (accounts.length > 0) {
                this._msalService.instance.setActiveAccount(accounts[0]);
                accountInfo = this._msalService.instance.getActiveAccount();
            }
        }

        return accountInfo !== null;
    }
}
